import httpClient from '@utils/httpClient.js';

export const getAgentTypes = () => httpClient.get('api/agent-types');

export const getAgents = (profileId) => httpClient.get(`api/profiles/${profileId}/ai-agents`);

export const getAgentsWithStatus = (profileId) => httpClient.get(`api/profiles/${profileId}/ai-agents/with-status`);

export const getAgent = (profileId, agentId) => httpClient.get(`api/profiles/${profileId}/ai-agents/${agentId}`);

export const createAgent = (profileId, data) => httpClient.post(`api/profiles/${profileId}/ai-agents`, data);

export const updateAgent = (profileId, agentId, data) => httpClient.put(`api/profiles/${profileId}/ai-agents/${agentId}`, data);

export const deleteAgent = (profileId, agentId) => httpClient.delete(`api/profiles/${profileId}/ai-agents/${agentId}`);

export const getChats = (profileId, agentId) => httpClient.get(`api/profiles/${profileId}/ai-agents/${agentId}/chats`);

export const sendMessage = (profileId, agentId, message) => httpClient.post(`api/profiles/${profileId}/ai-agents/${agentId}/chats`, { message });

export const clearChats = (profileId, agentId) => httpClient.delete(`api/profiles/${profileId}/ai-agents/${agentId}/chats`);

export const getActivities = (profileId, agentId, limit = 50) => httpClient.get(`api/profiles/${profileId}/ai-agents/${agentId}/activities?limit=${limit}`);
